export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RichText.vue?vue&type=template&id=53cd5f9c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/RichText.vue?vue&type=template&id=53cd5f9c&scoped=true
// module id = 105
// module chunks = 0